/**
 * Read-only rendering for the math exercise preview (`Blocks/Assignments/Editor/Math/Preview/*`).
 * The only place app-admin loads KaTeX (RND-196 decision 10).
 *
 * `renderMathText` mirrors app-student's `shared/ui/TextBlock.vue` on purpose — `$…$` delimits
 * inline math, everything else is escaped text — so what the author previews is what the player
 * draws.
 */
import katex from 'katex'

/** The same split as the player: an odd part is math, an even part is text. */
const MATH_DELIMITER = /\$([^$]+)\$/g

const escapeHtml = (value: string): string =>
  value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')

/**
 * Escaped text plus KaTeX's own markup — safe to bind with `v-html`. `throwOnError: false` renders a
 * malformed formula in red instead of throwing, which is what an author needs to see mid-edit.
 */
export const renderMathText = (value: string): string =>
  value
    .split(MATH_DELIMITER)
    .map((part, index) => (index % 2 === 1
      ? katex.renderToString(part, { throwOnError: false })
      : escapeHtml(part)))
    .join('')
